import { defineMessages } from '../define';

export const offline = defineMessages(
  {
    'offline.save': 'Vista fyrir ónettengt',
    'offline.save_short': 'Vista',
    'offline.saved': 'Vistað',
    'offline.remove': 'Fjarlægja',
    'offline.redownload': 'Sækja aftur',
    'offline.retry': 'Reyna aftur',
    'offline.save_all': 'Vista allt mitt',
    'offline.save_all_desc': 'Öll lögin þín í tækið, til notkunar án nets.',
    'offline.save_setlist': 'Vista lagalista',
    'offline.save_folder': 'Vista möppu',
    'offline.all_title': 'Allt mitt',
    'offline.kind.song': 'Lag',
    'offline.kind.collection': 'Lagalisti',
    'offline.all_sections': 'Allar raddir',
    'offline.all_sections_desc': 'Líka nótur og æfingaskrár hinna raddanna (meira pláss).',
    'offline.estimate': 'Um {size}',
    'offline.songs': { one: '{count} lag', other: '{count} lög' },
    'offline.files_progress': '{done} af {total} skrám',
    'offline.percent': '{percent} %',
    'offline.keep_open': 'Haltu appinu opnu á meðan',
    'offline.waiting_network': 'Bíður eftir netsambandi',
    'offline.waiting_retry': 'Reyni aftur eftir smá stund',
    'offline.bar_saving': 'Vista: {title}',
    'offline.covered_by': 'Þegar vistað með: {names}',
    'offline.saving_started': 'Vistun hafin',
    'offline.save_done': 'Vistað fyrir ónettengt: {title}',
    'offline.removed': 'Fjarlægt af tækinu',
    'offline.remove_confirm': 'Fjarlægja af tækinu?',
    'offline.remove_body': 'Skrárnar eru fjarlægðar af þessu tæki. Þú getur vistað aftur hvenær sem er.',
    'offline.status.pending': 'Bíður niðurhals',
    'offline.status.downloading': 'Sæki…',
    'offline.status.complete': 'Vistað',
    'offline.status.update': 'Uppfærsla tiltæk',
    'offline.status.error': 'Vistun stöðvaðist',
    'offline.badge.saved': 'Vistað fyrir ónettengt',
    'offline.badge.downloading': 'Verið að vista fyrir ónettengt',
    'offline.badge.update': 'Uppfærsla tiltæk',
    'offline.badge.pending': 'Bíður niðurhals',
    'offline.badge.error': 'Vistun stöðvaðist',
    'offline.error.offline': 'Tengstu netinu til að vista.',
    'offline.error.gone': 'Þetta er ekki lengur aðgengilegt.',
    'offline.error.storage': 'Ekki tókst að nota geymslu tækisins.',
    'offline.error.network': 'Netsamband rofnaði.',
    'offline.error.storage_full': 'Geymslurými tækisins er fullt.',
    'offline.error.unsupported': 'Þessi vafri getur ekki vistað fyrir ónettengt.',
    'offline.error.server': 'Þjónninn hafnaði niðurhalinu.',
    'offline.error.invalid': 'Skrá stemmdi ekki – reyndu aftur.',
    'offline.install_title': 'Settu appið á heimaskjáinn til að vista lög',
    'offline.install_body': 'Lög sem eru vistuð í Safari sjást ekki í appinu á heimaskjánum og Safari eyðir þeim eftir viku.',
    'offline.install_link': 'Sjá leiðbeiningar',
    'offline.next_up_prompt': 'Vista lagalista æfingarinnar fyrir ónettengt?',
    'offline.next_up_dismiss': 'Ekki núna',
    'offline.storage.packs': 'Vistað fyrir ónettengt',
    'offline.storage.no_packs': 'Ekkert vistað enn. Veldu „Vista fyrir ónettengt“ við lag eða lagalista.',
    'offline.storage.recent': 'Nýlega opnuð lög',
    'offline.storage.recent_desc': { one: '{count} lag geymt sjálfkrafa · {size}', other: '{count} lög geymd sjálfkrafa · {size}' },
    'offline.storage.recent_empty': 'Síðustu 10 lögin sem þú opnar eru geymd sjálfkrafa.',
    'offline.storage.clear_recent': 'Hreinsa',
    'offline.storage.ready': 'Tilbúið án nets',
    'offline.storage.not_ready': 'Ekki enn tilbúið án nets',
    'offline.storage.check_sw': 'Appið er uppsett og virkt',
    'offline.storage.check_shell': 'Viðmót appsins er geymt',
    'offline.storage.check_core': 'Dagatal, félagatal og lagaskrá eru geymd',
    'offline.storage.check_pack': 'Að minnsta kosti eitt lag er vistað',
    'offline.storage.persisted': 'Gögnin eru varin gegn sjálfvirkri hreinsun vafrans.',
    'offline.storage.not_persisted': 'Vafrinn gæti hreinsað gögnin ef pláss verður lítið.',
    'offline.storage.persist': 'Verja gögnin',
    'offline.storage.synced': 'Síðast borið saman við þjóninn {time}',
    'offline.storage.sync_failed': 'Náði ekki sambandi – notast er við það sem er vistað.',
    'offline.storage.sync_now': 'Uppfæra',
    'offline.storage.size_of': '{done} af {total}',
    'offline.logout_pending_title': { one: '{count} óvistuð breyting – skrá út samt?', other: '{count} óvistaðar breytingar – skrá út samt?' },
    'offline.logout_pending_body': 'Þær hafa ekki náð til þjónsins og glatast ef þú skráir þig út núna. Tengstu netinu og reyndu aftur til að vista þær.',
    'offline.logout_anyway': 'Skrá út samt',
  },
  {
    'offline.save': 'Save for offline',
    'offline.save_short': 'Save',
    'offline.saved': 'Saved',
    'offline.remove': 'Remove',
    'offline.redownload': 'Download again',
    'offline.retry': 'Try again',
    'offline.save_all': 'Save all my songs',
    'offline.save_all_desc': 'All your songs on this device, for use without a connection.',
    'offline.save_setlist': 'Save setlist',
    'offline.save_folder': 'Save folder',
    'offline.all_title': 'All my songs',
    'offline.kind.song': 'Song',
    'offline.kind.collection': 'Setlist',
    'offline.all_sections': 'All voices',
    'offline.all_sections_desc': "Also the other voices' sheets and practice tracks (more space).",
    'offline.estimate': 'About {size}',
    'offline.songs': { one: '{count} song', other: '{count} songs' },
    'offline.files_progress': '{done} of {total} files',
    'offline.percent': '{percent}%',
    'offline.keep_open': 'Keep the app open meanwhile',
    'offline.waiting_network': 'Waiting for a connection',
    'offline.waiting_retry': 'Retrying shortly',
    'offline.bar_saving': 'Saving: {title}',
    'offline.covered_by': 'Already saved with: {names}',
    'offline.saving_started': 'Saving started',
    'offline.save_done': 'Saved for offline: {title}',
    'offline.removed': 'Removed from this device',
    'offline.remove_confirm': 'Remove from this device?',
    'offline.remove_body': 'The files are removed from this device. You can save them again at any time.',
    'offline.status.pending': 'Waiting to download',
    'offline.status.downloading': 'Downloading…',
    'offline.status.complete': 'Saved',
    'offline.status.update': 'Update available',
    'offline.status.error': 'Saving stopped',
    'offline.badge.saved': 'Saved for offline',
    'offline.badge.downloading': 'Saving for offline',
    'offline.badge.update': 'Update available',
    'offline.badge.pending': 'Waiting to download',
    'offline.badge.error': 'Saving stopped',
    'offline.error.offline': 'Connect to the internet to save.',
    'offline.error.gone': 'This is no longer available.',
    'offline.error.storage': "Could not use this device's storage.",
    'offline.error.network': 'The connection was lost.',
    'offline.error.storage_full': 'The device storage is full.',
    'offline.error.unsupported': 'This browser cannot save for offline use.',
    'offline.error.server': 'The server refused the download.',
    'offline.error.invalid': 'A file did not match – try again.',
    'offline.install_title': 'Add the app to your Home Screen to save songs',
    'offline.install_body': 'Songs saved in Safari are not visible to the Home-Screen app, and Safari deletes them after a week.',
    'offline.install_link': 'Show me how',
    'offline.next_up_prompt': "Save this rehearsal's setlist for offline use?",
    'offline.next_up_dismiss': 'Not now',
    'offline.storage.packs': 'Saved for offline',
    'offline.storage.no_packs': 'Nothing saved yet. Choose “Save for offline” on a song or setlist.',
    'offline.storage.recent': 'Recently opened songs',
    'offline.storage.recent_desc': { one: '{count} song kept automatically · {size}', other: '{count} songs kept automatically · {size}' },
    'offline.storage.recent_empty': 'The last 10 songs you open are kept automatically.',
    'offline.storage.clear_recent': 'Clear',
    'offline.storage.ready': 'Ready offline',
    'offline.storage.not_ready': 'Not ready offline yet',
    'offline.storage.check_sw': 'The app is installed and active',
    'offline.storage.check_shell': 'The app itself is stored',
    'offline.storage.check_core': 'Calendar, directory and song list are stored',
    'offline.storage.check_pack': 'At least one song is saved',
    'offline.storage.persisted': 'Data is protected from automatic browser clean-up.',
    'offline.storage.not_persisted': 'The browser may clear this data if space runs low.',
    'offline.storage.persist': 'Protect data',
    'offline.storage.synced': 'Last checked with the server {time}',
    'offline.storage.sync_failed': 'Could not connect – using what is saved.',
    'offline.storage.sync_now': 'Check now',
    'offline.storage.size_of': '{done} of {total}',
    'offline.logout_pending_title': { one: '{count} unsaved change – sign out anyway?', other: '{count} unsaved changes – sign out anyway?' },
    'offline.logout_pending_body': 'They have not reached the server and will be lost if you sign out now. Connect to the internet and try again to save them.',
    'offline.logout_anyway': 'Sign out anyway',
  },
);
